import { handleAction } from '@gef-ui/utils/fsaActions';
import identity from "ramda/es/identity";
import mergeRight from "ramda/es/mergeRight";
import prop from "ramda/es/prop";
import ramdaUseWith from "ramda/es/useWith";
import { urlsActions } from '../../constants';
export default handleAction(urlsActions.MERGE_URLS, ramdaUseWith(mergeRight, [
    identity,
    prop('payload')
]), {});
